// @flow

import { Dimensions, ScaledSize } from "react-native";

const window: ScaledSize = Dimensions.get("window");
export const screenHeight: number = window.height;
export const screenWidth: number = window.width;

export const isDeviceTablet: boolean = true;
